import { Language } from '../../../common/languages.js';

export interface IEventAdditionalSitesLang {
  header: string;
  buttonText: string;
  subheading: string;
}

export interface IEventPlacesLang {
  name: string;
}

export interface IEventLang {
  clientId: string;
  header: string;
  pictureText: string;
  underPictureText: string;
  additionalSites: Array<IEventAdditionalSitesLang>;
  underTextData: string;
  places: Array<IEventPlacesLang>;
}

export type IEventLangState = {
  [lang in Language]: IEventLang;
};

export class EventLangClass implements IEventLang {
  clientId: string;
  header: string;
  pictureText: string;
  underPictureText: string;
  additionalSites: Array<IEventAdditionalSitesLang>;
  underTextData: string;
  places: Array<IEventPlacesLang>;

  constructor(event?: Partial<IEventLang>) {
    this.clientId = event?.clientId ?? '';
    this.header = event?.header ?? '';
    this.pictureText = event?.pictureText ?? '';
    this.underPictureText = event?.underPictureText ?? '';
    this.additionalSites = event?.additionalSites ?? [];
    this.underTextData = event?.underTextData ?? '2025';
    this.places = event?.places ?? [];
  }
}
